import React from 'react';
import GatewayInstallStateView from '../views/GatewayInstallStateView';
import ResetRequestState from '../gateway/ResetRequestState';
export default {
  install(molten) {
    molten.addPlugin('AttributeValueRenderer', {
      objectType: 'gateway',
      attrName: 'gateway.installed',
      renderer: (data, props, context) => {
        return /*#__PURE__*/React.createElement(GatewayInstallStateView, {
          option: {
            value: data?.value
          }
        });
      }
    });
    molten.addPlugin('AttributeValueRenderer', {
      objectType: 'desiredGateway',
      attrName: 'desiredGateway.installed',
      renderer: (data, props, context) => {
        return /*#__PURE__*/React.createElement(GatewayInstallStateView, {
          option: {
            value: data?.value
          }
        });
      }
    });
    molten.addPlugin('AttributeValueRenderer', {
      objectType: 'gateway',
      attrName: 'gateway.resetRequestMetadata.state',
      renderer: (value, style, object, context) => {
        if (value != null) {
          return /*#__PURE__*/React.createElement(ResetRequestState, {
            value: Array.isArray(value) ? value[0] : null,
            isDetail: true
          });
        }
        return null;
      }
    });
  }
};